import React from "react";
import "./Blog.css";
import { Link } from "react-router-dom";
import img1 from "./../../images/blog/default/blog1.jpeg";
import img2 from "./../../images/blog/default/blog2.jpeg";
import img3 from "./../../images/blog/blog3.jpeg";
import img4 from "./../../images/blog/blog4.jpeg";
import img5 from "./../../images/blog/blog5.jpeg";
import img6 from "./../../images/blog/blog6.jpeg";
import img7 from "./../../images/blog/blog7.jpeg";
import img8 from "./../../images/blog/blog8.jpeg";
import img9 from "./../../images/blog/blog9.jpeg";
import img10 from "./../../images/blog/blog10.jpeg";
import img11 from "./../../images/blog/blog11.jpeg";
import img12 from "./../../images/blog/blog12.jpeg";
import img13 from "./../../images/blog/blog13.jpeg";
import img14 from "./../../images/blog/blog14.jpeg";
import img15 from "./../../images/blog/blog15.jpeg";
import img16 from "./../../images/blog/blog16.jpeg";
import img17 from "./../../images/blog/blog17.jpeg";
import img18 from "./../../images/blog/blog18.jpeg";
import img19 from "./../../images/blog/blog19.jpeg";
import img20 from "./../../images/blog/blog20.jpeg";
import img21 from "./../../images/blog/blog21.jpeg";
import img22 from "./../../images/blog/blog22.jpeg";
import img23 from "./../../images/blog/blog23.jpeg";
import img24 from "./../../images/blog/blog24.jpeg";
import img25 from "./../../images/blog/blog25.jpeg";
import img26 from "./../../images/blog/blog26.jpeg";
import img27 from "./../../images/blog/blog27.jpeg";
import img28 from "./../../images/blog/blog28.jpeg";
import img29 from "./../../images/blog/blog29.jpeg";
import img30 from "./../../images/blog/blog30.jpeg";
import img31 from "./../../images/blog/blog31.jpeg";
import img32 from "./../../images/blog/blog32.jpeg";
import img33 from "./../../images/blog/blog33.jpeg";
import img34 from "./../../images/blog/blog34.jpeg";
import img35 from "./../../images/blog/blog35.jpeg";
import img36 from "./../../images/blog/blog36.jpeg";
import img37 from "./../../images/blog/blog37.jpeg";
import img38 from "./../../images/blog/blog38.jpeg";
import img39 from "./../../images/blog/blog39.jpeg";
import img40 from "./../../images/blog/blog40.jpeg";
import img41 from "./../../images/blog/blog41.jpeg";
import img42 from "./../../images/blog/blog42.jpeg";
import img43 from "./../../images/blog/blog43.jpeg";
import img44 from "./../../images/blog/blog44.jpeg";
import img45 from "./../../images/blog/blog45.jpeg";
import img46 from "./../../images/blog/blog46.jpeg";
import img47 from "./../../images/blog/blog47.jpeg";
import img48 from "./../../images/blog/blog48.jpeg";
import img49 from "./../../images/blog/blog49.jpeg";
import img50 from "./../../images/blog/blog50.jpeg";
import img51 from "./../../images/blog/blog51.jpeg";
import img52 from "./../../images/blog/blog52.jpeg";
import img53 from "./../../images/blog/blog53.jpeg";
import img54 from "./../../images/blog/blog54.jpeg";
import img55 from "./../../images/blog/blog55.jpeg";
import img56 from "./../../images/blog/blog56.jpeg";


import Header from "../Common/Header";
import Footer from "../Common/Footer";

const blogData = [
  {
    id: 1,
    slug: "latest-trends-textile-garment-printing-technology-cheran-machines",
    title: "Latest Innovations in Textile Printing Machines",
    date: "March 4, 2026",
    image: img1,
    description:
      "Explore the newest advancements in textile printing machinery that are transforming the garment industry.",
  },
  {
    id: 2,
    slug: "screen-printing-vs-digital-printing-which-is-better-for-your-business-in-2026-cheran-machines",
    title: "How Automation Improves Garment Production",
    date: "March 11, 2026",
    image: img2,
    description:
      "Automation plays a vital role in improving efficiency and reducing production costs in textile manufacturing.",
  },
  {
    id: 3,
    slug: "top-benefits-sublimation-printing-high-quality-apparel-sportswear-cheran-machines",
    title: "Top Benefits of Sublimation Printing for High-Quality Apparel and Sportswear",
    date: "March 18, 2026",
    image: img3,
    description:
      "Discover the key advantages of sublimation printing for sportswear and custom apparel, and how it delivers vibrant, long-lasting designs.",
  },
  {
    id: 4,
    slug: "scale-printing-business-manual-to-automatic-printing-machines-cheran-machines",
    title: "How to Scale Your Printing Business from Manual to Automatic Printing Machines",
    date: "March 25, 2026",
    image: img4,
    description:
      "Learn how upgrading from manual to automatic printing machines can boost production efficiency and help your printing business grow.",
  },

  {
    id: 5,
    slug: "choosing-the-right-printing-machine-for-small-vs-large-units-cheran-machines",
    title: "Choosing the Right Printing Machine for Small vs Large Units | Cheran Machines",
    date: "April 1, 2026",
    image: img5,
    description:
      "Learn how to choose the right printing machine for your business. Compare small and large units, cost, speed, and efficiency with Cheran Machines.",
  },

    {
    id: 6,
    slug: "why-after-sales-service-is-crucial-for-industrial-machinery-cheran-machines",
    title: "Why After Sales Service is Crucial for Industrial Machinery | Cheran Machines",
    date: "April 4, 2026",
    image: img6,
    description:
      "Learn why after sales service is crucial for industrial machinery. Improve efficiency, reduce downtime, and boost ROI with Cheran Machines.",
  },

  {
    id: 7,
    slug: "common-printing-defects-how-to-avoid-them-complete-guide-cheran-machines",
    title: "Common Printing Defects & How to Avoid Them: A Complete Guide | CHERAN MACHINES",
    date: "April 6, 2026",
    image: img7,
    description:
      "Learn common textile printing defects, causes & how to avoid them. Improve print quality, reduce errors & boost efficiency with Cheran Machines.",
  },
    {
    id: 8,
    slug: "choosing-the-right-printing-machine-for-small-vs-large-units-cheran-machines",
    title: "Choosing the Right Printing Machine for Small vs Large Units | Cheran Machines",
    date: "April 8, 2026",
    image: img8,
    description:
      "Learn how to choose the right printing machine for your business. Compare small and large units, cost, speed, and efficiency with Cheran Machines.",
  },
   {
    id: 9,
    slug: "made-in-india-textile-printing-machines-vs-imported-machines-2026-cheran-machines",
    title: "Made in India Textile Printing Machines vs Imported Machines: Which is Better in 2026? | CHERAN MACHINES",
    date: "April 15, 2026",
    image: img9,
    description:
      "Compare Made in India textile printing machines vs imported machines in 2026. Discover cost, quality, ROI & why CHERAN MACHINES is the best choice. ",
  },

   {
    id: 10,
    slug: "how-a-tshirt-gets-printed-step-by-step-guide-cheran-machines",
    title: "Electric Drill Machine 2310: Features, Uses & Buying Guide | SRB Polymers",
    date: "April 18, 2026",
    image: img10,
    description:
      "Explore Electric Drill Machine 2310 features, uses, specs & buying guide. Find the best drill machine for home use in India with SRB Polymers.",
  },

  {
    id: 11,
    slug: "textile-machinery-trends-2026-automation-smart-manufacturing-cheran-machines",
    title: "Textile Machinery Trends 2026: Automation & Smart Manufacturing | CHERAN MACHINES ",
    date: "April 27, 2026",
    image: img11,
    description:
      "The textile industry is undergoing a massive transformation in 2026, driven by textile automation 2026, smart textile production, and industrial automation textile solutions. Manufacturers are no longer relying on traditional",
  },
  {
    id: 12,
    slug: "daily-maintenance-tips-to-extend-textile-machine-life-cheran-machines",
    title: "Daily Maintenance Tips to Extend Textile Machine Life | CHERAN MACHINES",
    date: "April 30, 2026",
    image: img12,
    description:
      "In the fast-paced textile industry, machines are the backbone of production. Whether it’s spinning, weaving, or finishing, maintaining peak performance is essential for consistent output and profitability.",
  },

  {
    id: 13,
    slug: "micro-registration-printing-machine-textile-printing -cheran-machines",
    title: "Best Micro Registration Printing Machine for Textile Printing | Cheran Machines ",
    date: "May 05, 2026",
    image: img13,
    description:
      "In today’s competitive textile industry, achieving high precision printing and consistent quality is no longer optional it’s essential. Whether you run a garment unit, a custom t-shirt business, or a large-scale textile production facility",
  },
   {
    id: 14,
    slug: "double-tray-sublimation-transfer-machine-textile-printing-cheran-machines",
    title: "Best Double Tray Sublimation Transfer Machine for Textile Printing | Cheran Machines",
    date: "May 08, 2026",
    image: img14,
    description:
      "The textile industry is rapidly evolving with advanced sublimation transfer technology that delivers vibrant, durable, and high-quality prints. Businesses today demand faster production, consistent output, and cost efficiency—this is where a double tray sublimation transfer machine becomes essential.",
  },
  {
    id: 15,
    slug: "manual-printing-machine-textile-garment-industry-features-benefits-buying-guide-2026 -cheran-machines",
    title: "Manual Printing Machine for Textile & Garment Industry: Features, Benefits & Buying Guide 2026 | CHERAN MACHINES ",
    date: "May 12, 2026",
    image: img15,
    description:
      "Explore CHERAN manual printing machine features, benefits, applications, pricing, and buying guide for textile & garment industries in 2026.",
  },
  {
    id: 16,
    slug: "electric-dryer-conveyor-curing-machine-textile-printing-features-benefits-2026-cheran-machines",
    title: "Electric Dryer Conveyor Curing Machine for Textile Printing: Features, Benefits 2026 | CHERAN MACHINES",
    date: "May 14, 2026",
    image: img16,
    description:
      "Discover CHERAN electric dryer conveyor curing machine features, benefits, applications, and buying guide for textile printing in 2026.",
  },
   {
    id: 17,
    slug: "how-screen-dryers-improve-textile-printing-quality-production-speed-cheran-machines",
    title: "How Screen Dryers Improve Textile Printing Quality & Production Speed | CHERAN MACHINES",
    date: "May 18, 2026",
    image: img17,
    description:
      "Discover how screen dryers improve textile printing quality, drying speed, and production efficiency with CHERAN MACHINES screen dryer solutions.",
  },
   {
    id: 18,
    slug: "how-foot-mounted-type-stirrer-motors-improve-industrial-mixing-efficiency-cheran-machines",
    title: "How Foot Mounted Type Stirrer Motors Improve Industrial Mixing Efficiency | CHERAN MACHINES",
    date: "May 20, 2026",
    image: img18,
    description:
      "Improve industrial mixing efficiency with durable foot mounted stirrer motors from CHERAN MACHINES for smooth performance.",
  },
   {
    id: 19,
    slug: "stretching-clamp-for-screen-printing-best-tool-for-perfect-fabric-stretching -cheran-machines",
    title: "Stretching Clamp for Screen Printing: Best Tool for Perfect Fabric Stretching | Cheran Machines",
    date: "May 25, 2026",
    image: img19,
    description:
      "Screen printing is a process where precision decides the final output quality. One of the most important factors that affects print clarity is mesh tension and fabric alignment.",
  },
   {
    id: 20,
    slug: "x-wel-exposing-machine-for-screen-printing-high-precision-uv-exposure-unit-cheran-machines",
    title: "X-Wel Exposing Machine for Screen Printing: High Precision UV Exposure Unit | Cheran Machines",
    date: "May 27, 2026",
    image: img20,
    description:
      "In modern screen printing, precision and consistency are the most important factors that decide print quality. ",
  },
  {
    id: 21,
    slug: "screen-washer-for-screen-printing-features-benefits-buying-guide-2026-cheran-machines",
    title: "Screen Washer for Screen Printing: Features, Benefits & Buying Guide 2026 | Cheran Machines",
    date: "June 02, 2026",
    image: img21,
    description:
      "In the textile and industrial printing industry, maintaining clean screens is one of the most important factors for achieving sharp and professional print results. A Screen Washer for Screen Printing plays a major role in ensuring",
  },

  {
    id: 22,
    slug: "best-stirrer-motor-stand-type-for-industrial-mixing-applications-2026-cheran-machines",
    title: "Best Stirrer Motor Stand Type for Industrial Mixing Applications | Cheran Machines",
    date: "June 04, 2026",
    image: img22,
    description:
      "Industrial manufacturing and processing industries depend heavily on precision, consistency, and efficiency. One of the most essential machines supporting these operations is the Stirrer Motor Stand Type.",
  },

  {
    id: 23,
    slug: "why-gas-dryers-are-essential-for-high-speed-textile-printing-production-cheran-machines",
    title: "Why Gas Dryers Are Essential for High-Speed Textile Printing Production | CHERAN MACHINES",
    date: "June 10, 2026",
    image: img23,
    description:
      "In today's competitive textile industry, speed, consistency, and production quality play a critical role in business success. Textile printing companies are constantly",
  },

  {
    id: 24,
    slug: "why-dual-heat-tray-machines-improve-heat-transfer-production-efficiency-cheran-machines",
    title: "Why Dual Heat Tray Machines Improve Heat Transfer Production Efficiency | CHERAN MACHINES  ",
    date: "June 12, 2026",
    image: img24,
    description:
      "The textile and garment printing industry is evolving rapidly, with businesses seeking faster production methods, better print quality, and improved operational efficiency.",
  },
    {
    id: 25,
    slug: "ceramic-flash-curer-complete-guide-for-fast-and-efficient-screen-printing-curing-in-2026-cheran-machines ",
    title: "Ceramic Flash Curer: Complete Guide for Fast and Efficient Screen Printing Curing in 2026 | CHERAN MACHINES ",
    date: "June 16, 2026",
    image: img25,
    description:
      "The textile and garment printing industry is evolving rapidly, with businesses seeking faster production methods, better print quality, and improved operational efficiency.",
  },
    {
    id: 26,
    slug: "manual-printing-machine-complete-guide-for-textile-and-garment-printing-2026-cheran-machines ",
    title: "Manual Printing Machine: Complete Guide for Textile and Garment Printing in 2026 | CHERAN MACHINES ",
    date: "June 18, 2026",
    image: img26,
    description:
      "The textile and garment industry continues to evolve with new printing technologies, but the Manual Printing Machine remains one of the most reliable and cost-effective solutions for fabric and apparel decoration.",
  },

      {
    id: 27,
    slug: "micro-registration-printing-machine-accurate-textile-printing-2026-cheran-machines",
    title: "Micro Registration Printing Machine for Accurate Textile Printing in 2026 | CHERAN MACHINES",
    date: "June 23, 2026",
    image: img27,
    description:
      "The textile industry is continuously evolving with advanced technologies that help manufacturers achieve better quality, faster production, and accurate printing results. In modern textile manufacturing,",
  },

      {
    id: 28,
    slug: "electric-flash-curer-ir-curer-fast-efficient-screen-printing-curing-cheran-machines",
    title: "Electric Flash Curer (IR Curer): Complete Guide for Fast and Efficient Screen Printing Curing | CHERAN MACHINES",
    date: "June 25, 2026",
    image: img28,
    description:
      "In the modern textile and garment printing industry, achieving perfect print quality with faster production has become a major requirement. The curing process plays an important role in making screen-printed designs durab",
  },


        {
    id: 29,
    slug: "cheran-machines-electric-dryer-conveyor-curing-machine-working-process-specifications-2026",
    title: "Cheran Machines Electric Dryer Conveyor Curing Machine: Working Process, Specifications 2026",
    date: "July 01, 2026",
    image: img29,
    description:
      "In the modern printing and textile industry, achieving fast production with consistent quality is essential. A reliable drying and curing system plays a major role in improving productivity and maintaining print quality.",
  },

      {
    id: 30,
    slug: "best-diesel-curing-machine-textile-printing-cheran-machines",
    title: "Best Diesel Curing Machine for Textile Printing Industry – Cheran Machines",
    date: "July 04, 2026",
    image: img30,
    description:
      "In the textile printing industry, achieving high-quality prints with excellent durability requires an efficient curing process. A proper curing machine helps improve ink bonding,",
  },

      {
    id: 31,
    slug: "digital-heat-transfer-fusing-machine-for-garment-industry-cheran-machines",
    title: "Best Digital Heat Transfer Fusing Machine for Garment Industry: Features & Benefits Explained | Cheran Machines",
    date: "July 07, 2026",
    image: img31,
    description:
      "The garment industry requires advanced technology and efficient machinery to achieve high-quality production with accuracy and speed. A Digital Heat Transfer Fusing Machine plays an important role in modern garment manufacturing",
  },


      {
    id: 32,
    slug: "embossing-machine-working-principle-features-benefits-textile-industry-cheran-machines",
    title: "Embossing Machine: Working Principle, Features & Benefits for Textile Industry | Cheran Machines",
    date: "July 09, 2026",
    image: img32,
    description:
      "The textile industry is continuously adopting advanced machinery to improve fabric quality, production speed, and design possibilities. An Embossing Machine is one of the most important textile processing machines used to create attractive patterns",
  },

        {
    id: 33,
    slug: "premium-sleek-digital-twins-heat-transfer-fusing-machine-textile-printing-cheran-machines",
    title: "Premium Sleek Digital Twins Heat Transfer Fusing Machine for Textile Printing | Cheran Machines",
    date: "July 14, 2026",
    image: img33,
    description:
      "The textile printing industry has witnessed remarkable technological advancements over the past decade. As businesses strive to produce high-quality printed garments with greater efficiency",
  },
        {
    id: 34,
    slug: "premium-dual-heat-tray-for-heat-transfer-printing-cheran-machines",
    title: "Premium Dual Heat Tray for Heat Transfer Printing | Cheran Machines",
    date: "July 16, 2026",
    image: img34,
    description:
      "In today's competitive textile and garment printing industry, manufacturers require equipment that delivers precision, consistency, and high production efficiency.",
  },

          {
    id: 35,
    slug: "best-heat-transfer-machine-for-label-printing-why-choose-cherans-cute-cheran-machines",
    title: "Best Heat Transfer Machine for Label Printing: Why Choose Cheran's Cute? | Cheran Machines",
    date: "July 21, 2026",
    image: img35,
    description:
      "In today's competitive garment and textile industry, high-quality label printing is essential for building a strong brand identity. Every clothing label represents your brand and provides important product information, making precision and durability crucial.",
  },

        {
    id: 36,
    slug: "how-to-choose-the-right-heat-transfer-machine-for-your-factory-cheran-machines",
    title: "How to Choose the Right Heat Transfer Machine for Your Factory | Cheran Machines",
    date: "July 23, 2026",
    image: img36,
    description:
      "In today's highly competitive textile and garment manufacturing industry, choosing the right Heat Transfer Machine is one of the most important decisions for improving production efficiency and product quality.",
  },

   {
    id: 37,
    slug: "multi-head-vs-single-head-heat-transfer-machine-cheran-machines",
    title: "Multi-Head vs Single-Head Heat Transfer Machine | Cheran Machines",
    date: "Aug 03, 2026",
    image: img37,
    description:
      "Choosing the right heat transfer machine is one of the most important decisions for any garment printing, textile manufacturing, or apparel customization business.",
  },

   {
    id: 38,
    slug: "why-cute-square-cfs-0606-is-best-for-t-shirt-printing-cheran-machines",
    title: "Cute Square CFS 0606 for T-Shirt Printing | Cheran Machines",
    date: "Aug 05, 2026",
    image: img38,
    description:
      "The T-shirt printing industry is experiencing rapid growth, driven by increasing demand for custom apparel, promotional clothing, corporate uniforms, sportswear, and personalized fashion. ",
  },

  {
    id: 39,
    slug: "best-sublimation-transfer-machine-for-textile-printing-cheran-machines",
    title: "How to Choose the Best Sublimation Transfer Machine for Textile Printing | Cheran Machines",
    date: "Aug 11, 2026",
    image: img39,
    description:
      "The textile printing industry has evolved rapidly with advancements in digital printing technology, making dye sublimation printing one of the most preferred methods for producing vibrant, durable, and high-quality prints.",
  },

  {
    id: 40,
    slug: "why-roll-to-roll-sublimation-transfer-machines-are-essential-for-high-volume-textile-printing-cheran-machines",
    title: "How to Choose the Best Roll to Roll Sublimation Transfer Machines Are Essential for High-Volume Textile Printing | Cheran Machines",
    date: "Aug 13, 2026",
    image: img40,
    description:
      "The textile printing industry is rapidly evolving as manufacturers seek faster, more efficient, and cost-effective production methods.",
  },

   {
    id: 41,
    slug: "best-sublimation-transfer-machine-for-textile-printing-cheran-machines",
    title: "How to Choose the Best Sublimation Transfer Machine for Textile Printing | Cheran Machines",
    date: "Aug 17, 2026",
    image: img41,
    description:
      "The textile printing industry has evolved rapidly with advancements in digital printing technology, making dye sublimation printing one of the most preferred methods for producing vibrant, durable, and high-quality prints.",
  },

  {
    id: 42,
    slug: "why-roll-to-roll-sublimation-transfer-machines-are-essential-for-high-volume-textile-printing-cheran-machines",
    title: "How to Choose the Best Roll to Roll Sublimation Transfer Machines Are Essential for High-Volume Textile Printing | Cheran Machines",
    date: "Aug 20, 2026",
    image: img42,
    description:
      "The textile printing industry is rapidly evolving as manufacturers seek faster, more efficient, and cost-effective production methods.",
  },

  {
    id: 43,
    slug: "how-a-6-station-auto-fusing-machine-improves-garment-production-cheran-machines",
    title: "How a 6 Station Auto Fusing Machine Improves Garment Production | Cheran Machines ",
    date: "Aug 25, 2026",
    image: img43,
    description:
      "In modern garment manufacturing, productivity, consistency, and finishing quality play an important role in meeting customer expectations.",
  },

  {
    id: 44,
    slug: "automatic-fusing-machine-complete-guide-garment-industry-cheran-machines",
    title: "Automatic Fusing Machine: Complete Guide for Garment Industry | Cheran Machines",
    date: "Aug 27, 2026",
    image: img44,
    description:
      "In the garment industry, production speed, consistency, and finishing quality play an important role in determining overall manufacturing efficiency.",
  },

   {
    id: 45,
    slug: "heat-and-cool-fusing-machine-complete-guide-for-garment-manufacturing-cheran-machines",
    title: "Heat and Cool Fusing Machine: Complete Guide for Garment Manufacturing | Cheran Machines",
    date: "Sep 2, 2026",
    image: img45,
    description:
      "In modern garment manufacturing, achieving consistent quality, strong bonding, and a professional finish is essential. ",
  },

  {
    id: 46,
    slug: "single-head-automatic-screen-printing-machine-features-benefits-uses-cheran-machines",
    title: "Single Head Automatic Screen Printing Machine: Features, Benefits & Uses | Cheran Machines",
    date: "Sep 5, 2026",
    image: img46,
    description:
      "Screen printing is one of the most widely used printing methods in the garment and textile industry.",
  },

  {
    id: 47,
    slug: "flash-curing-machine-for-t-shirt-printing-complete-guide-cheran-machines",
    title: "Flash Curing Machine for T-Shirt Printing: Complete Guide | CHERAN MACHINES",
    date: "Sep 8, 2026",
    image: img47,
    description:
      "In modern garment printing, producing a high-quality T-shirt is not only about creating an attractive design.",
  },

  
  {
    id: 48,
    slug: "how-to-choose-the-best-heat-transfer-machine-for-garments-cheran-machines",
    title: "How to Choose the Best Heat Transfer Machine for Garments | CHERAN MACHINES",
    date: "Sep 10, 2026",
    image: img48,
    description:
      "Garment printing has become an important part of the textile and apparel industry.",
  },

  {
    id: 49,
    slug: "best-flash-curing-machine-for-garment-printing-2026-cheran-machines",
    title: "Best Flash Curing Machine for Garment Printing in 2026 | CHERAN MACHINES",
    date: "Sep 15, 2026",
    image: img49,
    description:
      "In garment printing, achieving a strong, consistent and professional print finish depends on more than just choosing the right ink and printing technique.",
  },

  {
    id: 50,
    slug: "best-textile-dryer-machine-high-speed-production-cheran-machines",
    title: "Best Textile Dryer Machine for High-Speed Production | CHERAN MACHINES",
    date: "Sep 18, 2026",
    image: img50,
    description:
      "In the textile and garment industry, production speed matters, but speed alone is not enough. Manufacturers also need consistent drying, reliable equipment, controlled heat and an efficient production workflow.",
  },

  {
    id: 51,
    slug: "best-textile-printing-machines-for-garment-production-cheran-machines",
    title: "Best Textile Printing Machines for Garment Production | CHERAN MACHINES",
    date: "Sep 22, 2026",
    image: img51,
    description:
      "Textile printing has become an important part of modern garment production.",
  },

  {
    id: 52,
    slug: "garment-industry-machines-complete-guide-textile-printing-equipment-cheran-machines",
    title: "Garment Industry Machines: Complete Guide to Textile Printing Equipment | CHERAN MACHINES",
    date: "Sep 25, 2026",
    image: img52,
    description:
      "The garment industry has changed significantly with the development of modern machinery and production technology.",
  },

  {
    id: 53,
    slug: "electric-flash-curing-machine-for-screen-printing-cheran-machines",
    title: "Electric Flash Curing Machine for Screen Printing | CHERAN MACHINES",
    date: "Oct 5, 2026",
    image: img53,
    description:
      "Screen printing is widely used for decorating T-shirts, garments, textiles, bags, and other fabric products.",
  },

  {
    id: 54,
    slug: "gas-dryer-machine-textile-garment-industries-cheran-machines",
    title: "Gas Dryer Machine for Textile & Garment Industries | CHERAN MACHINES",
    date: "Oct 7, 2026",
    image: img54,
    description:
      "Drying is an important stage in textile and garment production.",
  },

  {
    id: 55,
    slug: "micro-registration-printing-machine-for-t-shirts-bags-garments-cheran-machines",
    title: "Micro Registration Printing Machine for T-Shirts, Bags & Garments | CHERAN MACHINES",
    date: "Oct 13, 2026",
    image: img55,
    description:
      "In garment and textile printing, accuracy matters just as much as print quality.",
  },

  {
    id: 56,
    slug: "how-to-choose-foot-mounted-stirrer-motor-for-industrial-mixing-cheran-machines",
    title: "How to Choose a Foot Mounted Stirrer Motor for Industrial Mixing | CHERAN MACHINES",
    date: "Oct 15, 2026",
    image: img56,
    description:
      "Industrial mixing is an important part of many manufacturing processes.",
  },

];

const BlogList = () => {
  return (
    <>
      <Header />

      <div className="cm-blog-list-page">
        <div className="cm-blog-container">
          {blogData.map((blog) => (
            <div className="cm-blog-card" key={blog.id}>

              {/* IMAGE */}
              <Link to={`/blog/${blog.slug}`} className="cm-blog-img-wrapper">
                <img src={blog.image} alt={blog.title} />
              </Link>

              {/* CONTENT */}
              <div className="cm-blog-content">
                <span className="cm-blog-date">{blog.date}</span>

                <h3 className="cm-blog-title">
                  <Link to={`/blog/${blog.slug}`}>
                    {blog.title}
                  </Link>
                </h3>

                <p className="cm-blog-desc">{blog.description}</p>

                <Link
                  to={`/blog/${blog.slug}`}
                  className="cm-blog-readmore"
                >
                  Read More →
                </Link>
              </div>

            </div>
           ))}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default BlogList;